module.exports = __webpack_public_path__ + "static/designWatch@2x-d0967c5be699afc4fe914c4304ba98e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/designWatch@2x.jpg
// module id = 2602
// module chunks = 168707334958949